import { render } from "./index.vue?vue&type=template&id=9844ac9c"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/users/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9844ac9c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9844ac9c', __exports__)) {
    console.log('reload')
    api.reload('9844ac9c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=9844ac9c", () => {
    console.log('re-render')
    api.rerender('9844ac9c', render)
  })

}


export default __exports__